export default __webpack_public_path__ + "fonts/ABB-UI-Icons-32x32-3KYbS.woff";